import { Injectable, NgZone } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
/**
 * Mit dieser Klasse kann die Snackbar genutzt und ein Custom-Style je nach Anforderung gesetzt werden.
 * Damit ist es möglich einen User beim fehlerhaften Senden zu informieren.
 *
 * A_25495 -Anzeige von Fehlern beim Versand
 */
export class SnackbarService {
  constructor(
    private readonly snackbar: MatSnackBar,
    private readonly zone: NgZone
  ) {}

  /**
   * Error Snackbar mit dem entsprechenden Styling.
   * @param err Die Errornachricht
   */
  public error(err: string): void {
    this.show(err, 'X', ['snack-bar-container', 'error']);
  }

  /**
   * Success Snackbar mit dem entsprechenden Styling.
   * @param success Die SuccessNachricht
   */
  public success(success: string): void {
    this.show(success, '', ['snack-bar-container', 'success'], 5000);
  }

  public info(info: string): void {
    this.show(info, '', ['snack-bar-container', 'info'], 10000);
  }

  private show(message: string, action: string, panelClass: string[], duration?: number): void {
    this.zone.run(() => {
      this.snackbar.open(message, action, {
        horizontalPosition: 'right',
        verticalPosition: duration ? 'bottom' : 'top',
        duration: duration,
        panelClass: panelClass
      });
    });
  }
}
